import IService from '../IService';

export default IService.extend({
  stopEntityXHR: function () {
    if (app.xhrExpected(this.entityXHR)) {
      this.entityXHR.abort();
      this.entityXHR = null;
    }
  },

  get: function (data) {
    const deferred = $.Deferred();

    this.stopEntityXHR();
    this.entityXHR = $.ajax({
      url: app.apiUrl('/api/v1/search/social/instagram/entities'),
      type: 'GET',
      data,
      error: function (xhr) {
        if (xhr.status === 401) {
          deferred.reject({ loggedOut: true });
        } else {
          deferred.reject();
        }
      },

      dataType: 'json',
      success: function (response) {
        if (response.users) {
          let entities = response.users; // temporary fix
          entities = entities.map((entity) => {
            const base = {
              id: null,
              query: null,
              name: null,
              type: null,
              verified: null,
              photo: null,
              source: 'instagram',
            };
            if (entity.hashtag) {
              Object.assign(base, {
                id: +entity.hashtag.id,
                query: entity.hashtag.name,
                name: entity.hashtag.name,
                count: entity.hashtag.media_count,
                type: 'HASHTAG',
              });
            } else if (entity.place) {
              Object.assign(base, {
                query: entity.place.location.pk,
                name: entity.place.title,
                subtitle: entity.place.subtitle,
                type: 'PLACE',
              });
            } else {
              Object.assign(base, {
                id: String(entity.id),
                query: String(entity.id),
                verified: entity.verified,
                name: entity.fullName || entity.userName,
                username: entity.userName,
                photo: entity.photo,
                type: 'USERNAME',
              });
            }
            if (_.isEmpty(base.name.trim())) {
              base.name = base.query;
            }
            base.text = base.name;
            return base;
          });
          deferred.resolve(entities);
        } else {
          deferred.reject(response);
        }
      },
    }).always(() => {
      this.entityXHR = null;
    });

    return Promise.resolve(deferred.promise());
  },
});
